import {ReportNavigation,ReportsNavigation,ResumeFsm} from '@/store/modules/fsm/messages';
import router from '@/router/index';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs, nextRouterHook, navigate } = api;
    let here = parent.active;

    here.init
      .to(here.reports);
    here.reports
      .to(here.report)
      .when(messageIs(ReportNavigation))
      .effect(nextRouterHook);
    here.report
      .to(here.reports)
      .when(messageIs(ReportNavigation,ReportsNavigation))
      .effect(nextRouterHook);/*
    here.reports
      .to()
      .when(messageIs(ResumeFsm))
      .effect(navigate(ReportsNavigation));
    here.report
      .to()
      .when(messageIs(ResumeFsm))
      .effect(navigate(ReportNavigation,{
        index: ({context}) => context.rootState.login.report.reportIndex
      }));*/
  }
};
